import { subscribeToStores } from './subscribe_to_stores';
import { flow } from '../../../lib/utilities';

export const start = (stores, onUpdate) => flow(
    subscribeToStores(onUpdate),
    onUpdate,
)(stores);
